import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const ContainerText = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-family: 'CenturyGothic';
  color: ${theme.colors.blue900};
`
